import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { UploadApi } from "../constants/Constants";
import {
  AWS_Access_Key_Id,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
} from "../constants/bucketCostant";
import InfoTable from "./InfoTable";
import Loader from "./Loader";

const Info = () => {
  const [responseData, setResponseData] = useState([]);
  // const [lastLogin,setLoginData]=useState(null)
  const [loader, setLoader] = React.useState(false);
  const state = useSelector((state) => state.user);
  const lastLogin = useSelector((state) => state.lastLogin);
  const folderName = useSelector((state) => state.FolderGet);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("bucketName", AWS_Bucket_Name());
    formdata.append("AwsAccessKey", AWS_Access_Key_Id());
    formdata.append("AwsSecretAccessKey", AWS_Secret_Access_Key());
    formdata.append("Region", AWS_Region());
    formdata.append("UserMail", state.email);

    try {
      let response = await axios.post(
        `${UploadApi}/apiUpload/GetLastUpdatedByAll`,
        formdata
      );
      if (response) {
        let updatedArray = response.data;

        const folderFilter = folderName?.FolderName;

        if (Array.isArray(folderFilter)) {
          updatedArray = response.data.filter((item) =>
            folderFilter.some((filterVal) =>
              item.folderName.includes(filterVal)
            )
          );
        } else if (!folderFilter) {
        } else {
          updatedArray = response.data.filter((item) =>
            item.folderName.includes(folderFilter)
          );
        }

        setLoader(false);
        setResponseData(updatedArray);
      }
    } catch (error) {
      //console.log(error);
      setLoader(false);
      setResponseData([]);
    }
  };

  return (
    <div>
      {loader ? (
        <div className="my-20">
          <Loader />
        </div>
      ) : (
        <section className="text-gray-600 body-font">
          <div
            className="container mt-3 mx-auto "
            style={{ maxWidth: "1432px" }}
          >
            {responseData.length !== 0 ? (
              <InfoTable data={responseData} lastLogin={lastLogin} />
            ) : (
              <div className="bg-white max-w-md border-t-2 mx-auto shadow-md rounded-md mt-32 p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  No Records Found
                </h2>
                <p className="text-gray-600">
                  We're sorry, but there are no records.
                </p>
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};

export default Info;
